import { paceInPreferredUnit, distanceInPreferredUnit, elevationInPreferredUnit } from "../../../services";

export const PdfExportValues = (waypoints, summaryUnitLabels) => {
  let i = 0;

  return waypoints.map((marker) => {
    const p = Math.floor(paceInPreferredUnit(marker.pace));
    const pace = isNaN(p)
      ? new Date(0).toISOString().substring(11, 19)
      : new Date(p * 1000).toISOString().substring(11, 19);
    const timeClean = marker.time.split(".")[0];
    const timeFormatted = timeClean;
    // const paceClean = pace.time.split(".")[0];
    const paceFormatted = pace.substring(3, 8); // Limit to "mm:ss"
    i++;
    return {
      numeration: i,
      title: `${marker.title}: ${Math.round((distanceInPreferredUnit(marker.distance) * 100) / 1000) / 100}${summaryUnitLabels[1]} / ${marker.elapsedTime}`,
      distance: `${
        Math.round((distanceInPreferredUnit(marker.secDist) * 100) / 1000) / 100 }`,
      gradeChange: `+${Math.round(marker.gradeUpHill)}% / ${Math.round(
        marker.gradeDownHill
      )}%`,
      elevChange: `+${Math.round(elevationInPreferredUnit(marker.elevGain))} / ${Math.round(
        elevationInPreferredUnit(marker.elevLoss))}`,
      type: `${marker.type}`,
      pace: paceFormatted,
      time: timeClean,
      elapsedTime: timeFormatted,
      secDist: Math.round((distanceInPreferredUnit(marker.secDist) * 100) / 1000) / 100,
      description: marker.description,
    };
  });
}